import { TableContainer } from "@/components/table-container";
import { RenderbusTag } from "@/components/renderbus-tag";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { BlockTabs } from "@/components";
import { RenderBillingDetails } from "./render-billing-detail";
import { useGlobalStore } from "@/store/GlobalStore";
import { DesktopVolumeDetail } from "./view/desktop-volume-detail";
import { useSearchConfig } from "./view/machine/hooks/useSearch";

const t = getTranslateNsT("center");

function BillingDetailsView() {
  const { isPictureUser, userInfo } = useGlobalStore();
  const { machineOptions } = useSearchConfig();
  return (
    <TableContainer>
      <RenderbusTag>{t("consumption_warning_detail")}</RenderbusTag>
      {!isPictureUser && (
        <BlockTabs
          showGapLine={!machineOptions?.length}
          items={[
            {
              label: t("tab_render") || "",
              children: <RenderBillingDetails />,
            },
            {
              label: t("tab_desktop") || "",
              hidden: !userInfo?.enableRemoteDesktop,
              children: <DesktopVolumeDetail />,
            },
          ]}
        />
      )}
      {isPictureUser && <RenderBillingDetails />}
    </TableContainer>
  );
}

export function BillingDetails() {
  return <BillingDetailsView />;
}
